export default __webpack_public_path__ + "static/icon-columns-0d622ab6d9a4898306dccd7938af32fd.svg";